import { FC, useMemo } from "react";
import EmptyDataIMG from "images/empty-data.svg";
import { Loader } from "../Loader";
import {
  StyledEmptyData,
  StyledEmptyDataContent,
  StyledEmptyDataImg,
  StyledEmptyDataImgContainer,
  StyledEmptyDataText,
} from "styles/components/empty-data";

interface EmptyDataProps {
  img?: string;
  text?: string;
  extraText?: string;
  height?: string;
  bgColor?: string;
  direction?: "row" | "column";
  className?: string;
  dataTestId?: string;
  isLoading?: boolean;
}

const EmptyData: FC<EmptyDataProps> = ({
  img = EmptyDataIMG,
  text = "No information yet",
  extraText,
  height,
  bgColor,
  direction,
  className,
  dataTestId,
  isLoading,
}) => {
  const renderedContent = useMemo(
    () =>
      isLoading ? (
        <Loader dataTestId={dataTestId && `${dataTestId}-loader`} />
      ) : (
        <StyledEmptyDataContent
          direction={direction}
          data-testid={dataTestId && `${dataTestId}-loader`}
        >
          <StyledEmptyDataImgContainer>
            <StyledEmptyDataImg
              src={img}
              alt="empty-data-img"
            ></StyledEmptyDataImg>
          </StyledEmptyDataImgContainer>
          <StyledEmptyDataText variant="h3">{text}</StyledEmptyDataText>
          {extraText ? (
            <StyledEmptyDataText variant="h3">{extraText}</StyledEmptyDataText>
          ) : null}
        </StyledEmptyDataContent>
      ),
    [dataTestId, direction, extraText, img, isLoading, text]
  );

  return (
    <StyledEmptyData
      height={height}
      bgColor={bgColor}
      className={className}
      data-testid={dataTestId}
    >
      {renderedContent}
    </StyledEmptyData>
  );
};

export default EmptyData;
